module.exports = __webpack_public_path__ + "static/media/logout.9e1685ee.svg";